import { render, staticRenderFns } from "./chainPass.vue?vue&type=template&id=918936f0&scoped=true"
import script from "./chainPass.vue?vue&type=script&lang=js"
export * from "./chainPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918936f0",
  null
  
)

export default component.exports